var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasRows()
      ? _c(
          "div",
          [
            _c("b-table", {
              class: _vm.isWidget
                ? [
                    "fixed-table",
                    "pb-3 smaller-font-content",
                    "size-by-cols",
                    "report-table",
                    _vm.colClass
                  ]
                : ["pb-3 smaller-font-content"],
              attrs: {
                small: "",
                hover: "",
                fields: _vm.getColumns(),
                items: _vm.getRows(),
                "per-page": _vm.perPage,
                filter: _vm.filter,
                "current-page": _vm.currentPage,
                "sort-by": _vm.sortBy,
                "sort-desc": _vm.sortDesc,
                id: "report-table"
              },
              on: {
                "update:sortBy": function($event) {
                  _vm.sortBy = $event
                },
                "update:sort-by": function($event) {
                  _vm.sortBy = $event
                },
                "update:sortDesc": function($event) {
                  _vm.sortDesc = $event
                },
                "update:sort-desc": function($event) {
                  _vm.sortDesc = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "CarrierName",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "datedim-primary" }, [
                          _vm.displayAsLink(data, "CarrierName")
                            ? _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "CarrierName"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "column-link",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.displayColumnValue(data)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(data.value))]
                                )
                              ])
                            : _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "CarrierName"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(data.value))])
                              ]),
                          _vm._v(" "),
                          _vm.isPrimaryDimensionColumn(data, "CarrierName") &&
                          _vm.hasSecondary
                            ? _c("span", { staticClass: "date-range" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.displayDateRange(data.item.dateRange)
                                    ) +
                                    ")"
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.getMatchingRow(data)
                          ? _c("div", { staticClass: "datedim-secondary" }, [
                              _vm.displayAsLink(
                                _vm.getMatchingRow(data),
                                "CarrierName"
                              )
                                ? _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "column-link",
                                        on: {
                                          click: function($event) {
                                            _vm.displayColumnValue(
                                              _vm.getMatchingRow(data)
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getMatchingRow(data).CarrierName
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMatchingRow(data).CarrierName
                                        )
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.isPrimaryDimensionColumn(
                                _vm.getMatchingRow(data),
                                "CarrierName"
                              ) && _vm.hasSecondary
                                ? _c("span", { staticClass: "date-range" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.displayDateRange(
                                            _vm.getMatchingRow(data).dateRange
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "TeamName",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "datedim-primary" }, [
                          _vm.displayAsLink(data, "TeamName")
                            ? _c("span", [
                                _vm.isPrimaryDimensionColumn(data, "TeamName")
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "column-link",
                                    on: {
                                      click: function($event) {
                                        return _vm.displayColumnValue(data)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(data.value))]
                                )
                              ])
                            : _c("span", [
                                _vm.isPrimaryDimensionColumn(data, "TeamName")
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(data.value))])
                              ]),
                          _vm._v(" "),
                          _vm.isPrimaryDimensionColumn(data, "TeamName") &&
                          _vm.hasSecondary
                            ? _c("span", { staticClass: "date-range" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.displayDateRange(data.item.dateRange)
                                    ) +
                                    ") "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.getMatchingRow(data)
                          ? _c("div", { staticClass: "datedim-secondary" }, [
                              _vm.displayAsLink(
                                _vm.getMatchingRow(data),
                                "TeamName"
                              )
                                ? _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "column-link",
                                        on: {
                                          click: function($event) {
                                            _vm.displayColumnValue(
                                              _vm.getMatchingRow(data)
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getMatchingRow(data).TeamName
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMatchingRow(data).TeamName
                                        )
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.isPrimaryDimensionColumn(
                                _vm.getMatchingRow(data),
                                "TeamName"
                              ) && _vm.hasSecondary
                                ? _c("span", { staticClass: "date-range" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.displayDateRange(
                                            _vm.getMatchingRow(data).dateRange
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "AgentFullName",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "datedim-primary" }, [
                          _vm.displayAsLink(data, "AgentFullName")
                            ? _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "AgentFullName"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "column-link",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.displayColumnValue(data)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(data.value))]
                                )
                              ])
                            : _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "AgentFullName"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(data.value))])
                              ]),
                          _vm._v(" "),
                          _vm.isPrimaryDimensionColumn(data, "AgentFullName") &&
                          _vm.hasSecondary
                            ? _c("span", { staticClass: "date-range" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.displayDateRange(data.item.dateRange)
                                    ) +
                                    ")"
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.getMatchingRow(data)
                          ? _c("div", { staticClass: "datedim-secondary" }, [
                              _vm.displayAsLink(
                                _vm.getMatchingRow(data),
                                "AgentFullName"
                              )
                                ? _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "column-link",
                                        on: {
                                          click: function($event) {
                                            _vm.displayColumnValue(
                                              _vm.getMatchingRow(data)
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getMatchingRow(data)
                                              .AgentFullName
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMatchingRow(data).AgentFullName
                                        )
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.isPrimaryDimensionColumn(
                                _vm.getMatchingRow(data),
                                "AgentFullName"
                              ) && _vm.hasSecondary
                                ? _c("span", { staticClass: "date-range" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.displayDateRange(
                                            _vm.getMatchingRow(data).dateRange
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "StateTitleAbbrev",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "datedim-primary" }, [
                          _vm.displayAsLink(data, "StateTitleAbbrev")
                            ? _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "StateTitleAbbrev"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "column-link",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.displayColumnValue(data)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(data.value))]
                                )
                              ])
                            : _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "StateTitleAbbrev"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(data.value))])
                              ]),
                          _vm._v(" "),
                          _vm.isPrimaryDimensionColumn(
                            data,
                            "StateTitleAbbrev"
                          ) && _vm.hasSecondary
                            ? _c("span", { staticClass: "date-range" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.displayDateRange(data.item.dateRange)
                                    ) +
                                    ")"
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.getMatchingRow(data)
                          ? _c("div", { staticClass: "datedim-secondary" }, [
                              _vm.displayAsLink(
                                _vm.getMatchingRow(data),
                                "StateTitleAbbrev"
                              )
                                ? _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "column-link",
                                        on: {
                                          click: function($event) {
                                            _vm.displayColumnValue(
                                              _vm.getMatchingRow(data)
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getMatchingRow(data)
                                              .StateTitleAbbrev
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMatchingRow(data)
                                            .StateTitleAbbrev
                                        )
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.isPrimaryDimensionColumn(
                                _vm.getMatchingRow(data),
                                "StateTitleAbbrev"
                              ) && _vm.hasSecondary
                                ? _c("span", { staticClass: "date-range" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.displayDateRange(
                                            _vm.getMatchingRow(data).dateRange
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "ProductName",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "datedim-primary" }, [
                          _vm.displayAsLink(data, "ProductName")
                            ? _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "ProductName"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "column-link",
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.displayColumnValue(data)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(data.value))]
                                )
                              ])
                            : _c("span", [
                                _vm.isPrimaryDimensionColumn(
                                  data,
                                  "ProductName"
                                )
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.displayRowIndex(data)))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(data.value))])
                              ]),
                          _vm._v(" "),
                          _vm.isPrimaryDimensionColumn(data, "ProductName") &&
                          _vm.hasSecondary
                            ? _c("span", { staticClass: "date-range" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.displayDateRange(data.item.dateRange)
                                    ) +
                                    ")"
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.getMatchingRow(data)
                          ? _c("div", { staticClass: "datedim-secondary" }, [
                              _vm.displayAsLink(
                                _vm.getMatchingRow(data),
                                "ProductName"
                              )
                                ? _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "column-link",
                                        on: {
                                          click: function($event) {
                                            _vm.displayColumnValue(
                                              _vm.getMatchingRow(data)
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getMatchingRow(data).ProductName
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMatchingRow(data).ProductName
                                        )
                                      )
                                    ])
                                  ]),
                              _vm._v(" "),
                              _vm.isPrimaryDimensionColumn(
                                _vm.getMatchingRow(data),
                                "ProductName"
                              ) && _vm.hasSecondary
                                ? _c("span", { staticClass: "date-range" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.displayDateRange(
                                            _vm.getMatchingRow(data).dateRange
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  _vm._l(_vm.dateColumns, function(dateColumn, k) {
                    return {
                      key: dateColumn,
                      fn: function(data) {
                        return [
                          _c("div", { key: k }, [
                            _vm._v(_vm._s(_vm.dateFormated(data.value)))
                          ])
                        ]
                      }
                    }
                  }),
                  _vm._l(_vm.policyTermColumns, function(policyTermColumn, t) {
                    return {
                      key: policyTermColumn,
                      fn: function(data) {
                        return [
                          _c("div", { key: t }, [
                            _vm._v(_vm._s(_vm.displayPolicyTerm(data.value)))
                          ])
                        ]
                      }
                    }
                  }),
                  _vm._l(_vm.phonenumberColumns, function(
                    phonenumberColumn,
                    l
                  ) {
                    return {
                      key: phonenumberColumn,
                      fn: function(data) {
                        return [
                          _c("div", { key: l }, [
                            _vm._v(_vm._s(_vm.phonenumberFormat(data.value)))
                          ])
                        ]
                      }
                    }
                  }),
                  {
                    key: "link",
                    fn: function(data) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "open-quote",
                            attrs: { href: "javascript:void(0);" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToQuote(
                                  {
                                    qId: "{" + data.item.QuoteID + "}"
                                  },
                                  data.item
                                )
                              }
                            }
                          },
                          [
                            _vm._v("Open "),
                            _c("i", {
                              staticClass: "fas fa-chevron-right",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        )
                      ]
                    }
                  },
                  _vm._l(_vm.numericColumns, function(numericColumn, i) {
                    return {
                      key: numericColumn,
                      fn: function(data) {
                        return [
                          _c("div", { key: i }, [_vm._v(_vm._s(data.value))]),
                          _vm._v(" "),
                          _vm.getMatchingRow(data)
                            ? _c("div", { key: (i + 1) * -1 }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getMatchingRow(data)[numericColumn]
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  }),
                  _vm._l(_vm.currencyColumns, function(column, j) {
                    return {
                      key: column,
                      fn: function(data) {
                        return [
                          _c("div", { key: j }, [
                            _vm._v(
                              _vm._s(_vm._f("currency-filter")(data.value))
                            )
                          ]),
                          _vm._v(" "),
                          _vm.getMatchingRow(data)
                            ? _c("div", { key: (j + 1) * -1 }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("currency-filter")(
                                        _vm.getMatchingRow(data)[column]
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  }),
                  _vm._l(_vm.tableLabels, function(h, c) {
                    return {
                      key: "HEAD_" + h,
                      fn: function(data) {
                        return [
                          _c("div", { key: c }, [
                            _c("span", [_vm._v(_vm._s(data.label))]),
                            _vm._v(" "),
                            _vm.getTooltip(h) && !_vm.isWidget
                              ? _c("i", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass: "fa fa-question-circle tip-icon",
                                  attrs: {
                                    title: _vm.getTooltip(h),
                                    placement: "bottom",
                                    "aria-hidden": "true"
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      }
                    }
                  })
                ],
                null,
                true
              )
            }),
            _vm._v(" "),
            [
              !_vm.isWidget
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm float-md-right",
                      on: {
                        click: function($event) {
                          return _vm.exportCSV()
                        }
                      }
                    },
                    [_vm._v("Download CSV")]
                  )
                : _vm._e()
            ],
            _vm._v(" "),
            !_vm.isWidget
              ? _c("b-pagination", {
                  staticClass:
                    "pagination b-pagination pagination-md float-md-left",
                  attrs: {
                    "total-rows": _vm.rowCount,
                    "per-page": _vm.perPage,
                    "aria-controls": "report-table"
                  },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              : _vm._e()
          ],
          2
        )
      : _vm.isLoading === false && _vm.hasRows() === false
      ? _c("div", { staticStyle: { "text-align": "center" } }, [
          _c("p", { staticStyle: { "font-size": "2em" } }, [
            _vm._v("We're Sorry.")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("There is currently no data for the chosen report settings.")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4787aba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4787aba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/DatatableBlock.vue
// module id = null
// module chunks = 